<td>
    <img src="{{images.small.url}}" />
</td>
<td class="narrow">
    <!--<button type="button" class="approve btn btn-success">{{t 'common.approve'}}</button>-->
    <button type="button" class="reject btn btn-danger">{{t 'common.reject'}}</button>
</td>
